import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import INFTProperties from '../../models/INFTProperties'
import { IHuskyNFTCard } from '../Cards/HuskyNFTCard'
import BaseDetail from './BaseDetail'


export default function HuskyNFTDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IHuskyNFTCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  const tokenName = detailTokenItem ? `${collection.name} #${tokenItem.tokenId}` : collection.name
  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem) {
      result = [
        {
          key: 'Rarity',
          value: detailTokenItem.rarity
        },
        {
          key: 'Type',
          value: detailTokenItem.type
        },
        {
          key: 'Background',
          value: detailTokenItem.background
        }
      ]
    }

    return result
  }

  function getNFTDescription() {
    return (
      <div>
        What is Husky NFT?
        <p>
          The Husky team are dedicated in utilizing the Husky Avax token, Husky NFTs, and unique real-world merchandise
          sold paired with NFTs to revolutionize and promote the Avalanche blockchain and the NFT marketplace.
        </p>
      </div>
    )
  }

  return (
    <BaseDetail {...props} description={getNFTDescription()} tokenItemName={tokenName} properites={getNFTProperties()}>
      {detailTokenItem ? <img src={detailTokenItem.image} alt={tokenName} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
